import { css, useTheme } from "@emotion/react"
import React from "react"

interface Props extends React.HTMLAttributes<HTMLSpanElement> {}

export const InlineSpan = ({ children, onClick, ...rest }: Props) => {
  const theme = useTheme()
  const inlineSpanTextStyle = css`
    font-family: Inter600;
    font-size: 14px;
    line-height: 17px;
    cursor: pointer;
    color: ${theme.colors.ctaMain};
    &:hover {
      color: ${theme.colors.ctaSecondaryTwo};
    }
  `

  return (
    <span css={inlineSpanTextStyle} onClick={onClick} {...rest}>
      {children}
    </span>
  )
}
